import React, { useState, useEffect } from "react";
import {getEmetteurs, 
  getISINs, 
  getModeAmortissements,
  getPeriodicites,
  getMaturites, 
  getSimulationDetails} from "../services/SimulatorService";
import { TranslationService } from "../services/TranslationService";

import { FormBuilder } from "./FormBuilder"
import { OATFormBuilderInputDetails } from "./OATFormBuilderDetails"

import Swal from 'sweetalert2';


const OATSimulatorInput = ({formData, updateFormData, clearFormData, resetIsins, setResetIsins, lang}) => {
  const [emetteurs, setEmetteurs] = useState([]);
  const [emetteur, setEmetteur] = useState();

  const [isins, setIsins] = useState([]);
  const [isin, setIsin] = useState();

  const [modeAmortissements, setModeAmortissements] = useState([]);
  const [periodicites, setPeriodicites] = useState([]);
  const [maturiteEnAnnes, setMaturiteEnAnnes] = useState([]);

  const [isInFine, setIsInFine] = useState(true);
  const [isPriceCalculDisabled, setIsPriceCalculDisabled] = useState(false);
 
  useEffect(() => {
    const fetchData = async () => {
      setEmetteurs(await getEmetteurs());
      setModeAmortissements(await getModeAmortissements(lang));
      setPeriodicites(await getPeriodicites(lang));
      setMaturiteEnAnnes(await getMaturites());
    };

    fetchData();
  }, [lang]);

  useEffect(() => {
    if(resetIsins){
      setEmetteur({});
      setIsin({});
      setResetIsins(false);
    }
  }, [resetIsins]);

  const onEmetteurChange = async (event) => {
    const newEmetteur = event.target.value;

    clearFormData();
    setEmetteur(newEmetteur);

    if(newEmetteur){
      setIsins(await getISINs(newEmetteur, "OAT"));
    }
  };

  const onIsinChange = async (event) => {
    const newIsin = event.target.value;
    setIsin(newIsin);

    let details = await getSimulationDetails(newIsin)
    clearFormData();
    updateFormData(details);
    onDateBlur({target: {name: "dateEcheance", value: details.dateEcheance}})
    if(newIsin){
      setIsInFine(details.modeAmortissement === "IF");
    }
  };
  

  const onModeAmortissementChanged = (e) => {
    var isInFine = e.target.value === "IF";

    var updates = {
      modeAmortissement: e.target.value,
      differe: isInFine ? "0" : formData.differe
    }

    updateFormData(updates);
    setIsInFine(isInFine);
  }

  const onCalculTypeChange = (event) => {
    const { _, value } = event.target;

    if(value == "prix"){
      setIsPriceCalculDisabled(false);
      updateFormData({ ...formData, "prix": "" });
    }else{
      setIsPriceCalculDisabled(true);
      updateFormData({ ...formData, "tauxRendement": "" });
    }
  }

  const onFormChange = (event) => {
    const { name, value } = event.target;
    updateFormData({ ...formData, [name]: value });
  };

  const onDateBlur = (event) => {
    const { name, value } = event.target;
    let lowerDate, upperDate;
    if(name === "dateValeur"){
      lowerDate = value;
      upperDate = formData.dateEcheance;
    }else{
      lowerDate = formData.dateValeur;
      upperDate = value;
    }

    if(lowerDate >= upperDate){
      showAlert();
    }
  };

  const showAlert = () => {
    Swal.fire({
      text: TranslationService.translate("datesInputErrorMessage", lang),
      icon: 'error',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#3085d6', // Change the color of the "OK" button
    });
  };

  const formDetails = OATFormBuilderInputDetails ({
    emetteur,
    emetteurs,
    onEmetteurChange,
    isin,
    isins,
    onIsinChange,
    onModeAmortissementChanged,
    isInFine,
    modeAmortissements,
    periodicites,
    maturiteEnAnnes,
    formData,
    onFormChange,
    onDateBlur,
    onCalculTypeChange,
    isPriceCalculDisabled,
    lang
  })

  return (
    <div>
      {formDetails.map((field, index) => (FormBuilder.buildField(field, index, lang)))}
    </div>
  );  
};

export default OATSimulatorInput;
